import React from "react";
import { Check, X } from "lucide-react";
import { EVIDENCE_LABELS, EVIDENCE_WEIGHTS, evidenceScore } from "../data/mock";

export const EvidencePanel = ({ evidence }) => {
  const score = evidenceScore(evidence);
  const band =
    score >= 80 ? { label: "Strong", color: "text-success", bg: "bg-success-bg", bar: "bg-success" }
    : score >= 55 ? { label: "Moderate", color: "text-signal", bg: "bg-secondary", bar: "bg-signal" }
    : { label: "Weak", color: "text-danger", bg: "bg-danger-bg", bar: "bg-danger" };

  return (
    <div data-testid="evidence-panel" className="bg-white border border-border">
      <div className="px-4 py-3 border-b border-border flex items-center justify-between">
        <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-muted-foreground">
          Case-strength score
        </span>
        <span className={`font-mono text-sm font-semibold ${band.color}`}>
          {score} / 100 · {band.label}
        </span>
      </div>
      <div className="px-4 pt-4">
        <div className="h-1.5 w-full bg-secondary">
          <div className={`h-full ${band.bar}`} style={{ width: `${score}%` }} />
        </div>
      </div>
      <ul className="p-4 space-y-2">
        {Object.keys(EVIDENCE_LABELS).map((k) => {
          const has = evidence[k];
          return (
            <li key={k} className="flex items-center justify-between text-sm">
              <span className="flex items-center gap-2.5">
                <span
                  className={`h-5 w-5 flex items-center justify-center border ${
                    has ? "bg-success border-success text-white" : "bg-white border-border text-muted-foreground"
                  }`}
                >
                  {has ? <Check className="h-3 w-3" strokeWidth={2.5} /> : <X className="h-3 w-3" strokeWidth={2} />}
                </span>
                <span className={has ? "text-ink" : "text-muted-foreground"}>{EVIDENCE_LABELS[k]}</span>
              </span>
              <span className="font-mono text-[11px] text-muted-foreground">+{EVIDENCE_WEIGHTS[k]}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
